import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useGetShopEmbedHtmlSuspense from "@babackapp/private-api-client/client/use-get-embed-content";
import type { EmbedContent } from "@babackapp/private-api-client/generated/schema";
import { injectEmbedScript } from "./inject-embed-script";

export default function EmbedPage() {
  const [searchParams] = useSearchParams();
  const shopifyUrl = searchParams.get("shop");
  // Set by the admin "Créer un retour Baback" action (/shopifyproxyforaction).
  const orderId = searchParams.get("orderId") ?? undefined;

  if (!shopifyUrl) {
    throw new Error("shop param is required");
  }

  const { data } = useGetShopEmbedHtmlSuspense(shopifyUrl, true);
  const shopId = data.shopId;

  if (!shopId) return null;

  return (
    <>
      <EmbedScriptRunner embedData={data} shopId={shopId} orderId={orderId} />
      <div dangerouslySetInnerHTML={{ __html: data.html }} />
    </>
  );
}

function EmbedScriptRunner({
  embedData,
  shopId,
  orderId,
}: {
  embedData: EmbedContent;
  shopId: string;
  orderId?: string;
}) {
  useEffect(() => {
    injectEmbedScript(embedData, shopId, { orderId, lang: embedData.language });
  }, [embedData, shopId, orderId]);

  return null;
}
